import React from 'react';
import { Box } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import useGetRequest from 'src/hooks/useGetRequest';
import useModal from 'src/components/Modal/useModal';
import FlexbaseHttp, { createScheduledEmail } from 'src/utils/api';
import EditEmail from '../../emails/EditEmail';
import PreviewRawEmail from '../../emails/PreviewRawEmail';
import ScheduledEmailForm from '../../emails/ScheduledEmailModal/ScheduledEmailForm';
import EmailLoader from '../../emails/EmailLoader';

const ScheduleDripEmailHandlerContent = ({
  recipients: _recipients,
  ccs: _ccs,
  bccs: _bccs,
  subject: _subject,
  body: _body,
  emailTemplate,
  triggeredActionId,
  engagementId,
  onSuccess,
  taskId,
  onDismiss
}: any) => {
  const [recipients, setRecipients] = React.useState(_recipients);
  const [ccs, setCcs] = React.useState(_ccs);
  const [bccs, setBccs] = React.useState(_bccs);
  const [subject, setSubject] = React.useState(_subject);
  const [body, setBody] = React.useState(_body);
  const { isOpen, openModal, closeModal } = useModal();
  const { enqueueSnackbar } = useSnackbar();

  const handleSchedule = (schedulePayload: any, formikActions: any) => {
    createScheduledEmail(engagementId, {
      scheduledEmail: {
        ...schedulePayload,
        recipients,
        body,
        subject
      },
      completedTaskId: taskId,
    }).then(() => onSuccess('Email scheduled.'))
      .catch(() => {
        enqueueSnackbar('There was an issue scheduling the email.', {
          variant: 'error'
        });
      }).finally(() => formikActions.setSubmissionInFlight(false));
  };

  const editor = (
    <EditEmail
      engagementId={engagementId}
      onClose={closeModal}
      recipients={recipients}
      subject={subject}
      body={body}
      setRecipients={setRecipients}
      setSubject={setSubject}
      setBody={setBody}
    />
  );

  return (
    <Box height="100%" flexDirection="column" flexGrow="1">
      {isOpen && editor}
      <PreviewRawEmail
        recipients={recipients}
        ccs={ccs}
        bccs={bccs}
        subject={subject}
        body={body}
        engagementId={engagementId}
        onEditMessage={openModal}
        scheduledEmail={emailTemplate}
      />
      <Box pb={2} />
      <ScheduledEmailForm
        completedTaskId={taskId}
        onSubmit={handleSchedule}
        onClose={onDismiss}
        tertiaryButtonLabel="Dismiss"
      />
    </Box>
  );
};

const ScheduleDripEmailHandler = ({
  engagementId,
  triggeredAction,
  onSuccess,
  taskId,
  onDismiss
}: any) => {
  const { result: email, isLoading } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/preview-email/${triggeredAction.action.emailTemplate.id}/`,
    initialResult: {
      recipients: [],
      ccs: [],
      bccs: [],
      subject: '',
      body: '',
    }
  });

  if (isLoading) return <EmailLoader />;

  return (
    <ScheduleDripEmailHandlerContent
      recipients={email.recipients}
      ccs={email.ccs}
      bccs={email.bccs}
      subject={email.subject}
      body={email.body}
      engagementId={engagementId}
      emailTemplate={triggeredAction.action.emailTemplate}
      triggeredActionId={triggeredAction.id}
      onSuccess={onSuccess}
      taskId={taskId}
      onDismiss={onDismiss}
    />
  );
};

export default ScheduleDripEmailHandler;
